const PartiallyCheckedMinus = ({ ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M6 10H14" stroke="white" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
};

export default PartiallyCheckedMinus;
